export default "__VITE_ASSET__DnuE1uMg__"